// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Jh3Q","newExpiryDate":"styles_newExpiryDate__1H4R2","footer":"styles_footer__17pcR"};